import React, { useEffect, useState } from "react";
import ReportDate from "./ReportDate";
import MultiStepModal from "./MultiStepModal";
import {
  getFirestore,
  collection,
  getDocs,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { useTranslation } from "react-i18next";
const ReportModal = ({ isOpen, onClose, weatherData, field }) => {

  const [showNextModal, setShowNextModal] = useState(false);
  const [show, setShow] = useState(false);
  const [eror, setError] = useState("")
  const [result, setResults] = useState(" ")
  const [selectedField, setSelectedField] = useState(" ")
  const [activeDate, setActiveDate] = useState(null);
  const [previousDate, setPreviousDate] = useState(null);
  const { t, i18n } = useTranslation();
  const [isDateSelected, setIsDateSelected] = useState(false);
  const [formData, setFormData] = useState({
    fieldName: " ",
    farmerName: "",
    totalArea: "",
    cropName: "",
    variety: "",
    sowingDate: "",
    deviceNo: ""
  });
  useEffect(() => {
    setSelectedField(field)
   
  }, [field])

  useEffect(() => {
  // Check if dates are already in localStorage when component opens
  const storedDate = localStorage.getItem("date");
  if (storedDate) {
    try {
      const parsedDate = JSON.parse(storedDate);
      if (parsedDate.a) {
        setIsDateSelected(true);
      }
    } catch (error) {
      console.error("Error parsing stored date:", error);
      setIsDateSelected(false);
    }
  } else {
    setIsDateSelected(false);
  }
}, [isOpen]); // Run when modal opens


  const handleInputChange = (e) => {
    const { id, value } = e.target;
    console.log(value)
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };


const handleDateClick = (a, b) => {
  console.log("date", typeof (a), a, b)

  if (a) {
    localStorage.setItem("date", JSON.stringify({ a, b }))
    const [day, month, year] = a.split('-');
    const swappedDate = `${year}-${month}-${day}`;
    setActiveDate(swappedDate)
    setIsDateSelected(true); // Enable next button
  } else {
    // If a is null, clear localStorage and disable button
    localStorage.removeItem("date");
    setActiveDate(null)
    setIsDateSelected(false);
  }
  
  if (b) {
    const [Pday, Pmonth, Pyear] = b.split('-');
    const swappedPreviouseDate = `${Pyear}-${Pmonth}-${Pday}`;
    setPreviousDate(swappedPreviouseDate)
  } else {
    setPreviousDate(null);
  }
};

  const handleNext = () => {
    setShowNextModal(true);
    localStorage.setItem("report", JSON.stringify(formData));
  

  };

  const handlePrevious = () => {
    setShowNextModal(false);
  };

  const furtherNext = () => {
    setShow(true);
  }
  const getFieldData = async () => {
    try {
      const auth = getAuth();
      const user = auth.currentUser;

      if (user) {
        const db = getFirestore();
        const fieldsCollectionRef = collection(db, `users/${user.uid}/fields`);
        const querySnapshot = await getDocs(fieldsCollectionRef);

        const fields = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setResults(fields);

        // Match the field and update the modal formData
        const matchedField = fields.find(
          (field) => field.fieldName === selectedField
        );
        if (matchedField) {
          setFormData((prevData) => ({
            ...prevData,
            totalArea: matchedField.area,
            sowingDate: matchedField.sowingDate,
            cropName: matchedField.cropName,
            fieldName: matchedField.fieldName,
          }));
        }
      } else {
        throw new Error("User must be authenticated to retrieve field data.");
      }
    } catch (error) {
      console.error("Error:", error);
      setError(error.message);
    }
  };


  useEffect(() => {
    getFieldData();
  }
    , [selectedField]);
  return (
    isOpen && (
      <div className="fixed inset-0 bg-gray-900 bg-opacity-75 flex items-center justify-center z-50 overflow-y-auto overflow-x-hidden">
        <div className="bg-white w-full max-w-4xl p-8 rounded-xl shadow-2xl relative transition duration-300 ease-out transform hover:scale-105">
          <button
            className="absolute top-5 right-5 w-7 h-7 text-gray-700 hover:text-white bg-gray-200 hover:bg-red-600 rounded-full p-0 cursor-pointer transition duration-300"
            onClick={onClose}
            aria-label={t("Close modal")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="2"
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>

          <h2 className="text-2xl font-bold mb-6 text-center">{t("Report Form")}</h2>

          <form className="space-y-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              <div className="flex flex-col">
                <label htmlFor="fieldName" className="text-sm font-medium mb-1">
                  {t("Field Name")}
                </label>
                <input
                  type="text"
                  id="fieldName"
                  className="p-2 border rounded-md"
                  placeholder={t("Enter field name")}
                  value={formData.fieldName.split('-')[0]}
                  onChange={handleInputChange}
                />
              </div>

              <div className="flex flex-col">
                <label htmlFor="farmerName" className="text-sm font-medium mb-1">
                  {t("Farmer Name")}
                </label>
                <input
                  type="text"
                  id="farmerName"
                  className="p-2 border rounded-md"
                  placeholder={t("Enter farmer name")}
                  value={formData.farmerName}
                  onChange={handleInputChange}
                />
              </div>

              <div className="flex flex-col">
                <label htmlFor="totalArea" className="text-sm font-medium mb-1">
                  {t("Total Area (acres)")}
                </label>
                <input
                  type="number"
                  id="totalArea"
                  className="p-2 border rounded-md"
                  placeholder={t("Enter total area")}
                  value={formData.totalArea}
                  onChange={handleInputChange}
                />
              </div>

              <div className="flex flex-col">
                <label htmlFor="cropName" className="text-sm font-medium mb-1">
                  {t("Crop Name")}
                </label>
                <input
                  type="text"
                  id="cropName"
                  className="p-2 border rounded-md"
                  placeholder={t("Enter crop name")}
                  value={formData.cropName}
                  onChange={handleInputChange}
                />
              </div>

              <div className="flex flex-col">
                <label htmlFor="variety" className="text-sm font-medium mb-1">
                  {i18n.language === "ur" ? "اقسام" : "Variety"}
                </label>
                <input
                  type="text"
                  id="variety"
                  className="p-2 border rounded-md"
                  placeholder={t("Enter variety")}
                  value={formData.variety}
                  onChange={handleInputChange}
                />
              </div>

              <div className="flex flex-col">
                <label htmlFor="sowingDate" className="text-sm font-medium mb-1">
                  {i18n.language === "ur" ? "بوائی کی تاریخ" : "Sowing Date"}
                </label>
                <input
                  type="date"
                  id="sowingDate"
                  className="p-2 border rounded-md"
                  value={formData.sowingDate}
                  onChange={handleInputChange}
                />
              </div>

              <div className="flex flex-col">
                <label htmlFor="deviceNo" className="text-sm font-medium mb-1">
                  {i18n.language === "ur" ? "ڈوائس نمبر" : "Device No"}
                </label>
                <input
                  type="text"
                  id="deviceNo"
                  className="p-2 border rounded-md"
                  placeholder={t("Enter Device No")}
                  value={formData.deviceNo}
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </form>

          {/* Weather Box */}
          <div className="mt-8 p-4 border rounded-md shadow-md bg-gray-50">
            <h3 className="text-lg font-medium mb-4"> {i18n.language === "ur" ? "موسم کی تفصیلات" : "Weather Details"}</h3>
            <div className="flex justify-between">
              <div>
                <p className="text-sm font-medium">{t("Temperature")}:</p>
                <p>{weatherData?.temperature || t("N/A")}°C</p>
              </div>
              <div>
                <p className="text-sm font-medium">{t("Humidity")}:</p>
                <p>{weatherData?.humidity || t("N/A")}%</p>
              </div>
              <div>
                <p className="text-sm font-medium">{t("Precipitation")}:</p>
                <p>{weatherData?.precipitation} mm</p>
              </div>
            </div>
          </div>

          <div className="mt-8 flex justify-end space-x-4">
            <button
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition duration-300"
              onClick={handleNext}
            >
              {i18n.language === "ur" ? "اگلا" : "Next"}
            </button>
          </div>
        </div>

{showNextModal && (
  <div className="fixed inset-0 bg-gray-900 bg-opacity-75 flex items-center justify-center z-50 overflow-y-auto overflow-x-hidden">
    <div className="bg-white w-full max-w-4xl p-8 rounded-xl shadow-2xl relative transition duration-300 ease-out transform hover:scale-105">
      <h2 className="text-2xl font-bold mb-6 text-center">
        {i18n.language === "ur" ? "اگلا مرحلہ" : "Next Step"}
      </h2>

      <p className="text-center text-gray-600">
        {i18n.language === "ur" ? "رپورٹ ڈاؤن لوڈ کرنے کے لیے اپنی تاریخ منتخب کریں" : "Select your date to download the report"}
      </p>

      <ReportDate handleDate={handleDateClick} />
      <div className="mt-8 flex justify-between">
        <button
          className="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition duration-300"
          onClick={handlePrevious}
        >
          {i18n.language === "ur" ? "پچھلا" : "Previous"}
        </button>
        <button
          className={`px-4 py-2 rounded-md transition duration-300 ${
            isDateSelected 
              ? "bg-blue-600 text-white hover:bg-blue-700" 
              : "bg-gray-400 text-gray-200 cursor-not-allowed"
          }`}
          onClick={furtherNext}
          disabled={!isDateSelected}
        >
          {i18n.language === "ur" ? "اگلا" : "Next"}
        </button>
      </div>
    </div>
  </div>
)}

        {show && (
          <MultiStepModal
            onClose={setShow}
            activeDate={activeDate}
            previousDate={previousDate}
          />
        )}
      </div>
    )
  );
};

export default ReportModal;







